import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"

import { fbAuth } from "../../services/Firebase"
import { HiOutlineClock } from "react-icons/hi"
import { BiDish } from "react-icons/bi"
import { MdFavoriteBorder } from "react-icons/md"
import { useFavorite } from "../../contexts/FavoriteContext"

function RecipeSlide({ recipe, displayPage, favRecipes, setFavRecipes }) {
    const history = useHistory()
    const allowFavorite = useFavorite() 
    let user = {}
    const [ recipeIds, setRecipeIds ] = useState([])

    if (fbAuth.currentUser) {
        user = fbAuth.currentUser
    }

    useEffect(() => {
        const noDups = [ ...new Set(favRecipes) ]
        storeData( `${user.uid}-recipes`, noDups )
    }, [favRecipes, recipeIds, user.uid])

    const handleRouteRecipe = () => {
        history.push( `/recipe/${recipe.id}` )
        displayPage()
    }

    const storeData = ( key, data ) => localStorage.setItem( key, JSON.stringify(data) )

    const handleFavorite = (e) => {
        e.target.classList.add( "active" )
        setFavRecipes([ ...favRecipes, recipe ])
        setRecipeIds([ ...recipeIds, recipe.id ])
        console.log("Added to Favorite")
    }

    const handleTouch = (e) => e.target.classList.add( "active" )

    return (
        <>
            <section>
                { allowFavorite 
                    &&  <button className="favorite" onClick={handleFavorite} onTouchStart={handleTouch}>
                        <MdFavoriteBorder size="22.5px" /> 
                    </button>
                }
                <h3>{recipe.title}</h3>
                <div className="details active">
                    <HiOutlineClock />
                    <span>{`${recipe.readyInMinutes} minutes`}</span>
                </div>
                <div className="details active">
                    <BiDish />
                    <span>{`${recipe.servings} servings`}</span>
                </div>
            </section>
            <section className="recipeSlide" onClick={handleRouteRecipe} >
                <img src={recipe.image} alt="Wine" />
            </section>
        </>
    )
}

export default RecipeSlide
